import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { getPaymentStatus } from "../lib/api";
import { useCart } from "../context/CartContext";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const { clear } = useCart();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const res = await getPaymentStatus(sessionId);
        if (res.payment_status === "paid") { setStatus("paid"); clear(); return; }
        if (res.status === "expired" || attempts > 8) { setStatus("pending"); return; }
      } catch { if (attempts > 8) { setStatus("error"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <main className="min-h-screen flex items-center justify-center relative z-10 px-6">
      <div data-testid="payment-success-page" className="text-center max-w-lg">
        {status === "checking" && (
          <>
            <Loader2 className="w-12 h-12 animate-spin text-[#B0872A] mx-auto mb-6" />
            <h1 className="font-display text-4xl tracking-tight">Confirming your payment…</h1>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-16 h-16 text-[#4A3D6B] mx-auto mb-6" strokeWidth={1.2} />
            <h1 className="font-display text-5xl tracking-tight mb-4">Thank you</h1>
            <p className="text-[#57515F] mb-8">Your order is confirmed. A radiant ritual awaits — we&apos;ve emailed your receipt.</p>
            <Link to="/shop" data-testid="continue-shopping" className="btn-primary">Continue Shopping</Link>
          </>
        )}
        {(status === "pending") && (
          <>
            <Loader2 className="w-12 h-12 text-[#B0872A] mx-auto mb-6" />
            <h1 className="font-display text-4xl tracking-tight mb-4">Payment processing</h1>
            <p className="text-[#57515F] mb-8">This is taking a moment. You&apos;ll receive an email once it&apos;s confirmed.</p>
            <Link to="/shop" className="btn-secondary">Back to Shop</Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="w-16 h-16 text-[#8C3B3B] mx-auto mb-6" strokeWidth={1.2} />
            <h1 className="font-display text-4xl tracking-tight mb-4">Something went wrong</h1>
            <Link to="/shop" className="btn-secondary">Back to Shop</Link>
          </>
        )}
      </div>
    </main>
  );
}
